import { Helmet } from "react-helmet";
import AIServicesLayout from "../../sections/services/ai/aiServicesLayout";

const AIServicesPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x AI Services | Smart Innovation for Businesses</title>
                <meta name="description" content="code3x AI services help businesses innovate with intelligent tools, automation, and data-driven solutions." />
                <meta name="keywords" content="code3x AI services, artificial intelligence, machine learning, AI automation, digital intelligence, leading AI solutions provider, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/suite/ai" />
            </Helmet>

            <AIServicesLayout />
        </>
    );
}

export default AIServicesPage;